import { CircularProgress } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { CookiesProvider } from "react-cookie";
import { createRoot } from "react-dom/client";
import ConfigProvider from "./components/ConfigProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import ReactQueryProvider from "./components/ReactQueryProvider";
import ReduxProvider from "./components/ReduxProvider";
import Routes from "./containers/Routes";
import "./index.css";
import theme from "./theme";

// Locale par defaut : FR

const MOUNT_NODE = document.getElementById("root") as HTMLElement;
const root = createRoot(MOUNT_NODE);
root.render(
  // tslint:disable-next-line: jsx-wrap-multiline
  <ErrorBoundary>
    <ConfigProvider loading={<CircularProgress />}>
      <CookiesProvider>
        <ReduxProvider>
          <ReactQueryProvider>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <Routes />
            </ThemeProvider>
          </ReactQueryProvider>
        </ReduxProvider>
      </CookiesProvider>
    </ConfigProvider>
  </ErrorBoundary>
);
